// Real studio photos (uploaded by Julia). Served from /public/photos.
const FACE = "/photos/lash-face.jpg";       // brunette, full face, classic + brows
const SIGNATURE = "/photos/lash-signature.jpg"; // branded two-eye close-up
const GLOSSY = "/photos/lash-glossy.jpg";    // blonde, two eyes, glossy
const MACRO = "/photos/lash-macro.jpg";      // blonde single-eye macro
const JULIA = "/photos/julia-portrait.jpg";  // Julia — the artist
const LIFT = "/photos/lash-lift.jpg";        // lash elevation (lash lift)
const HOME = "/photos/hero-home.webp";       // home hero — lash close-up

export const IMAGES = {
  heroEye: HOME,
  heroMacro: SIGNATURE,
  introLash: GLOSSY,
  aboutPortrait: JULIA,
  aboutSecondary: MACRO,
  serviceByGroup: {
    "Classic": null,
    "Light Volume": FACE,
    "Volume": null,
    "Mega Volume": null,
    "Custom Designed": GLOSSY,
  },
  portfolio: [MACRO, SIGNATURE, GLOSSY, FACE, SIGNATURE, MACRO],
  gallery: [SIGNATURE, GLOSSY, MACRO, FACE, GLOSSY, SIGNATURE],
};

export const LOOKS = [
  { name: "Soft", tags: "Natural · Effortless", img: FACE, serviceId: "light-volume-full" },
  { name: "Wispy", tags: "Textured · Fluffy", img: GLOSSY, serviceId: "signature-full" },
  { name: "Full", tags: "Fuller · Defined", img: null, serviceId: "volume-full" },
  { name: "Dramatic", tags: "Bold · Dense", img: null, serviceId: "mega-volume-full" },
  { name: "Wet", tags: "Sleek · Glossy", img: LIFT, serviceId: "signature-full" },
  { name: "Textured", tags: "Fluffy · Piecey", img: null, serviceId: "classic-full" },
];

export const INSTAGRAM_URL = "https://instagram.com/slavic.lashes.brows";
